import type { IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IGetExampleAudioResponse } from './get-example-audio-response';
import { getExampleAudioResponseSchema } from './get-example-audio-response';

export async function getExampleAudioApi(
  slug: string,
  exampleId: number,
): Promise<IValidatedResponse<IGetExampleAudioResponse>> {
  return getRequest<IGetExampleAudioResponse>({
    path: `/challenges/${slug}/audio/example/${exampleId}`,
    schema: getExampleAudioResponseSchema,
  });
}
